import {
  FETCH_MONTHLY_REPORT_FAILURE,
  FETCH_MONTHLY_REPORT_REQUEST,
  FETCH_MONTHLY_REPORT_SUCCESS,
} from "./monthlyReportActionTypes";

export const fetchMonthlyReportRequest = () => ({
  type: FETCH_MONTHLY_REPORT_REQUEST,
});

export const fetchMonthlyReportSuccess = (data, key) => ({
  type: FETCH_MONTHLY_REPORT_SUCCESS,
  payload: data,
  key,
});


export const fetchMonthlyReportFailure = (error) => ({
  type: FETCH_MONTHLY_REPORT_FAILURE,
  payload: error,
});
